import React from 'react';
import SideNav from '+/nav/SideNav';
import Flashes from '+/flashes/Container';
import Modal from '+/modal';


const DefaultLayout = props => (
    <>
        <Flashes />
        <SideNav>
            {props.children}
        </SideNav>

        <Modal />
    </>
);

export default DefaultLayout;
